// GlobalStateContext.js
import React, { createContext, useState, useContext } from "react";

// Create a context
const GlobalStateContext = createContext();

// Create a provider component
export const GlobalStateProvider = ({ children }) => {
  const [DropMenu, setDropMenuVisibility] = useState(false); // Your state here
  const [CheckPage, setCheckPage] = useState(true); //  Check Page Visibility
  const [DontAllow, setDontAllow] = useState(false); // Used to Show Or Hide Navbar DropMenu for Homepage
  const [PagesWidthHeight, setPagesWidthHeight] = useState({
    height: 0,
  });
  const [AllPagesWidthHeight, setAllPagesWidthHeight] = useState({
    height: 0,
  });

  return (
    <GlobalStateContext.Provider
      value={{
        DropMenu,
        setDropMenuVisibility,
        CheckPage,
        setCheckPage,
        DontAllow,
        setDontAllow,
        PagesWidthHeight,
        setPagesWidthHeight,
        AllPagesWidthHeight,
        setAllPagesWidthHeight,
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};

// Custom hook to use global state
export const useGlobalState = () => useContext(GlobalStateContext);
